import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var switchTab = normalize.switchTab(function (options) {
  wx.switchTab(options);
}, CONTAINER_NAME.WECHAT);
export default switchTab;